import Vue from 'vue';
import { CONSTANTS } from '@/constants/guide';
export const arrayHasIndex = (array, index) =>
  Array.isArray(array) && array.hasOwnProperty(index);

export const normalizeString = str =>
  str
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();

export const download = (data, strFileName, strMimeType) => {
  let self = window, // this script is only for browsers anyway...
    u = 'application/octet-stream', // this default mime also triggers iframe downloads
    m = strMimeType || u,
    x = data,
    D = document,
    a = D.createElement('a'),
    z = function(a) {
      return String(a);
    },
    B = self.Blob || self.MozBlob || self.WebKitBlob || z,
    BB = self.MSBlobBuilder || self.WebKitBlobBuilder || self.BlobBuilder,
    fn = strFileName || 'download',
    blob,
    b,
    ua,
    fr;

  //go ahead and download dataURLs right away
  if (String(x).match(/^data\:[\w+\-]+\/[\w+\-]+[,;]/)) {
    return navigator.msSaveBlob // IE10 can't do a[download], only Blobs:
      ? navigator.msSaveBlob(d2b(x), fn)
      : saver(x); // everyone else can save dataURLs un-processed
  } //end if dataURL passed?

  try {
    blob = x instanceof B ? x : new B([x], { type: m });
  } catch (y) {
    if (BB) {
      b = new BB();
      b.append([x]);
      blob = b.getBlob(m); // the blob
    }
  }

  function d2b(u) {
    let p = u.split(/[:;,]/),
      t = p[1],
      dec = p[2] == 'base64' ? atob : decodeURIComponent,
      bin = dec(p.pop()),
      mx = bin.length,
      i = 0,
      uia = new Uint8Array(mx);

    for (i; i < mx; ++i) uia[i] = bin.charCodeAt(i);

    return new B([uia], { type: t });
  }

  function saver(url, winMode) {
    if ('download' in a) {
      //html5 A[download]
      a.href = url;
      a.setAttribute('download', fn);
      D.body.appendChild(a);
      a.click();
      D.body.removeChild(a);
      if (winMode === true) {
        self.URL.revokeObjectURL(a.href);
      }
      return true;
    }

    //do iframe dataURL download (old ch+FF):
    const f = D.createElement('iframe');
    D.body.appendChild(f);
    if (!winMode) {
      // force a mime that will download:
      url = 'data:' + url.replace(/^data:([\w\/\-\+]+)/, u);
    }

    f.src = url;
    setTimeout(function() {
      D.body.removeChild(f);
    }, 350);
  } //end saver

  if (navigator.msSaveBlob) {
    // IE10+ : (has Blob, but not a[download] or URL)
    return navigator.msSaveBlob(blob, fn);
  }

  if (self.URL) {
    // simple fast and modern way using Blob and URL:
    saver(self.URL.createObjectURL(blob), true);
  } else {
    // handle non-Blob()+non-URL browsers:
    if (typeof blob === 'string' || blob.constructor === z) {
      try {
        return saver('data:' + m + ';base64,' + self.btoa(blob));
      } catch (y) {
        return saver('data:' + m + ',' + encodeURIComponent(blob));
      }
    }

    // Blob but not URL:
    fr = new FileReader();
    fr.onload = function(e) {
      saver(this.result);
    };
    fr.readAsDataURL(blob);
  }
  return true;
}; /* end download() */

export const isMobile = () =>
  /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
    navigator.userAgent
  ) ||
  /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
    navigator.userAgent.substr(0, 4)
  );

export const forceLandscapeMode = async () => {
  if (
    document.fullscreenEnabled &&
    screen.orientation &&
    screen.orientation.lock
  ) {
    let goFullScreen = 'requestFullscreen';
    if ('mozRequestFullScreen' in document.documentElement) {
      goFullScreen = 'mozRequestFullScreen';
    } else if ('webkitRequestFullscreen' in document.documentElement) {
      goFullScreen = 'webkitRequestFullscreen';
    } else if ('msRequestFullscreen' in document.documentElement) {
      goFullScreen = 'msRequestFullscreen';
    }
    try {
      await document.documentElement[goFullScreen]();
      await screen.orientation.lock('landscape');
    } catch (e) {
      console.warn("Couldn't set Landscape Orientation For device.");
    }
  }
};

export const exitFullScreen = () => {
  let exitFullScreen = 'exitFullscreen';
  if ('mozExitFullscreen' in document) {
    exitFullScreen = 'mozExitFullscreen';
  } else if ('webkitExitFullscreen' in document) {
    exitFullScreen = 'webkitExitFullscreen';
  } else if ('msExitFullscreen' in document) {
    exitFullScreen = 'msExitFullscreen';
  }
  const promise = document[exitFullScreen]();
  if (promise && typeof promise.then === 'function') {
    promise
      .then(() => {})
      .catch(err => console.warn("Couldn't exit Full Screen"));
  }
};

export const textToFloat = text => {
  if (/^\d*?(\.?|,?)\d*?$/gm.test(text)) {
    return {
      floatValue:
        text === ''
          ? ''
          : [',', '.'].includes(text)
          ? 0.0
          : parseFloat(text.toString().replace(',', '.')),
      success: true
    };
  }
  return { success: false };
};

export const displaySubscriptionWarning = callback => {
  Vue.swal({
    icon: 'warning',
    html:
      'Für diesen Hund liegt bereits ein futalis Futter-Abo vor.<br/>Wollen Sie die Daten anpassen? Bitte kontaktieren Sie uns unter <span class="text-nowrap">+49 (0)341 39298790</span> oder das <a href="/configurator/interface_account/contact">Kontaktformular</a> in Ihrer Kontoverwaltung.<br/>Ihre Kunden können die Daten zudem in ihrem Kundenkonto auf <a href="https://futalis.de">www.futalis.de</a> bearbeiten.',
    showCancelButton: true,
    showConfirmButton: true,
    confirmButtonText: 'Fortfahren',
    confirmButtonColor: '#2778c4',
    cancelButtonText: 'Abbrechen',
    allowOutsideClick: () => true,
    allowEscapeKey: () => true,
    allowEnterKey: () => true
  }).then(result => {
    if (result.isConfirmed) {
      callback();
    }
  });
};

export function getPetAge(birthYear, birthMonth = 1) {
  const now = new Date();
  let years = now.getFullYear() - birthYear;
  let months = now.getMonth() + 1 - birthMonth;
  if (months < 0) {
    years -= 1;
    months += 12;
  }
  if (years === 0 && months === 0) {
    months = 1; // to prevent showing empty age for freshly born puppies
  }
  return {
    years: years,
    months: months,
  };
}

export function getPetAgeWeeks(birthDate, now) {
  const diffTime = Math.abs(now - birthDate);
  const diffWeeks = Math.ceil(diffTime / (1000 * 60 * 60 * 24 * 7));
  return diffWeeks > 0 ? diffWeeks : 1;
}

export function isInMobileViewport(element) {
  const rect = element.getBoundingClientRect()
  return (
      rect.top >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
  )
}

function getFormattedBirthDate(birthDate) {
  const now = new Date();
  let year, month, day;

  // If birthDate is an object, convert to string format (for consistnecy)
  if (typeof birthDate !== 'string') {
    year = birthDate.year || now.getFullYear();
    month = birthDate.month
        ? ('0' + birthDate.month).slice(-2)
        : ('0' + (now.getMonth() + 1)).slice(-2);
    day = birthDate.day
        ? ('0' + birthDate.day).slice(-2)
        : '01';
  } else {
    [year, month, day] = birthDate.split('-');
  }

  return { year, month, day };
}

export function getBreedGrowthCurveImageUrl(birthDate, breedId, size = 1) {
  const { year, month, day } = getFormattedBirthDate(birthDate);
  const breedImage = breedId + '.jpg';
  return `${CONSTANTS.APP.BASE_URL}/futalis/service/growthcurve/index.php?by=${year}&bm=${month}&bd=${day}&s=${size}&f=${breedImage}`;
}
